// removed by extract-text-webpack-plugin
module.exports = {"root":"MenuContent__root__2uilq","isClosed":"MenuContent__isClosed__1oIbq","isOpen":"MenuContent__isOpen__ErzQX","content":"MenuContent__content__3Hkip","arrowTop":"MenuContent__arrowTop__23o6H","arrowBelow":"MenuContent__arrowBelow__2xyIl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuContent/MenuContent.css
// module id = 2027
// module chunks = 0